import { Flex } from '@assets/component/UI/Flex/Flex';
import { useClientSettingStore, useStore } from '@assets/model/Store';
import { formatDollarStr, removeUrlQueryParams } from '@assets/utils/Formatting';
import { useNavUtils } from '@assets/utils/NavUtils';
import { observer } from 'mobx-react';
import { useState } from 'react';
import * as style from './DealThumbnailNoPdf.module.less';
import animData from './thumb_loading.json';
interface IDealThumbnailPropsNoPdf {
    name: string;
}

export const DealThumbnailNoPdf = observer((p: IDealThumbnailPropsNoPdf) => {
    const store = useStore();
    const clientStore = useClientSettingStore();

    const navUtils = useNavUtils();

    const query = store.createDataAccess(p.name);
    const companyName = query.companyName;

    const year = query.actualYear();
    const website = removeUrlQueryParams(query.value('website'));
    const ebitda = query.selectedEbitda(year);
    const companyDesc = query.value('company_overview_short');
    const industry = query.value('industry');
    const sub_industry = query.value('industrySubType');
    const metaFields = [
        { label: 'Website', value: website, isUrl: true },
        { label: 'CEO', value: query.value('company_ceo') },
        { label: 'Founded', value: query.value('year_founded') }
    ];

    const industry_display =
        industry +
        (clientStore.showSubIndustryInHeader ? ` - ${sub_industry}` : '');

    return (
        <div
            className={style.thumb}
            onClick={() => {
                navUtils.toReport(p.name);
            }}
        >
            <Flex direction="column">
                <div className={style.title}>{companyName}</div>
                <div className={style.industry}>{industry_display}</div>
                <div className={style.divider}></div>

                <Flex justify="between">
                    <div className={style.overview}>{companyDesc}</div>
                </Flex>
                <Flex
                    style={{
                        position: 'absolute',
                        bottom: '30px',
                        width: '100%',
                        padding: '0 20px 0 0px',
                        maxHeight: '50px'
                    }}
                    justify="between"
                >
                    {metaFields.map((field, index) => {
                        return (
                            <div
                                key={field.label}
                                className={style.fieldContainer}
                            >
                                <div className={style.fieldTitle}>
                                    {field.label}
                                </div>
                                <div className={style.fieldValue}>
                                    {field.isUrl &&
                                    field.value &&
                                    (field.value
                                        .toLowerCase()
                                        .startsWith('http') ||
                                        field.value
                                            .toLowerCase()
                                            .startsWith('www')) ? (
                                        <a
                                            href={field.value}
                                            target="_blank"
                                            style={{
                                                zIndex: 100000,
                                                color: '#243a5c'
                                            }}
                                            onClick={e => {
                                                e.stopPropagation();
                                            }}
                                        >
                                            {field.value}
                                        </a>
                                    ) : (
                                        field.value
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </Flex>
            </Flex>
            {/* {companyName} {industry} {sub_industry} <br /> Rev:{rev} EBITDA:
            {ebitda} */}
        </div>
    );
});
